export default __webpack_public_path__ + "static/media/job_icon.659bb820.svg";